import { useAuth } from '@/contexts/AuthContext';
import { useMyDelegations } from '@/hooks/useUserControl';
import { MenuContext } from '@/utils/menuVisibility';
import { useEventAccess } from './useEventAccess';

/** Relação da conta com eventos (próprios, delegados, financeiro) para montar menu e tela inicial. */
export const useMenuContext = (): MenuContext & { isLoading: boolean } => {
  const { currentUser } = useAuth();
  const access = useEventAccess();
  const { data: myDelegations } = useMyDelegations(!!currentUser);
  return {
    isAdmin: currentUser?.role === 'admin',
    ownsEvents: (access.data?.ownedEvents ?? 0) > 0,
    isTeam: (access.data?.delegatedEvents ?? 0) > 0,
    isFinance: !!myDelegations?.some((delegation) => delegation.role === 'FINANCEIRO'),
    isLoading: access.isLoading,
  };
};
